import { Column, GridRow } from '@shared';
import { DatePipe } from '@angular/common';
import { IChangeset } from '@shared-data';
import { IAvailabilityItem } from './availability-item.interface';

class AllAvailabilityChangeset implements IChangeset, IAvailabilityItem {
  status?: string;
  @Column({
    field: 'categoryName',
    title: 'Category',
    order: 0,
    width: 150,
    sortable: true,
    hidden: true,
    filterable: true,
    filterType: 'text',
    align: 'left',
  })
  categoryName?: string;

  @Column({
    field: 'restaurantName',
    title: 'Restaurant',
    order: 0.1,
    width: 80,
    sortable: true,
    visibleInDetailsView: false,
    visibleInQuickView: true,
    align: 'left',
  })
  restaurantName?: string;

  @Column({
    field: 'plu',
    title: 'PLU',
    order: 1.9,
    width: 90,
    filterable: true,
    filterType: 'custom',
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  plu?: string;
  restaurantId: string;
  categoryId?: string;

  @Column({
    field: 'tierName',
    title: 'Tier',
    order: 0,
    width: 150,
    sortable: true,
    visibleInDetailsView: false,
    visibleInQuickView: true,
    align: 'left',
  })
  tierName?: string;

  @Column({
    field: 'parItemId',
    title: 'Brink ID',
    order: 2,
    width: 90,
    filterable: true,
    filterType: 'custom',
    type: 'number',
    sortable: true,
    visibleInQuickView: true,
  })
  parItemId?: string;

  @Column({
    field: 'itemName',
    title: 'Product',
    order: 1,
    width: 200,
    filterable: true,
    filterType: 'custom',
    type: 'string',
    fixed: true,
    sortable: true,
    visibleInQuickView: true,
    align: 'left',
  })
  itemName: string;

  itemDescription?: string;

  @Column({
    field: 'isActive',
    title: 'Current In Store Availability',
    type: 'boolean',
    order: 12,
    width: 90,
    filterable: true,
    filterType: 'boolean',
    sortable: true,
    visibleInQuickView: true,
    hidden: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  isActive?: boolean;

  deliveryAvailability1P?: boolean = false;

  deliveryAvailability3P?: boolean = false;

  @Column({
    field: 'availabilityScheduledDate',
    hidden: true,
    title: 'Availability Change Scheduled Date',
    order: 9,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    editable: true,
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  availabilityScheduledDate: Date | null;

  pricingScheduledDate: Date | null;

  @Column({
    field: 'newAvailability',
    title: 'In Store Availability',
    order: 13,
    type: 'boolean',
    editable: true,
    width: 90,
    filterType: 'boolean',
    filterable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  newAvailability?: boolean;

  // @Column({
  //   field: 'newDeliveryAvailability1P',
  //   title: 'New 1P Delivery Availability',
  //   order: 13,
  //   type: 'boolean',
  //   editable: true,
  //   width: 90,
  //   filterType: 'boolean',
  //   filterable: true,
  //   visibleInQuickView: true,
  //   filterOptions: [
  //     { name: 'Available', value: true },
  //     { name: 'Not Available', value: false },
  //   ],
  // })
  newDeliveryAvailability1P?: boolean;

  @Column({
    field: 'newDeliveryAvailability3P',
    title: 'App/Delivery Availability',
    order: 13,
    type: 'boolean',
    editable: true,
    width: 90,
    filterType: 'boolean',
    filterable: true,
    visibleInQuickView: true,
    filterOptions: [
      { name: 'Available', value: true },
      { name: 'Not Available', value: false },
    ],
  })
  newDeliveryAvailability3P?: boolean;

  type: string = 'availability';

  @Column({
    field: 'itemType',
    title: 'Item Type',
    order: 0.2,
    width: 100,
    filterable: true,
    filterType: 'text',
    type: 'string',
    sortable: true,
    align: 'left',
  })
  itemType: string = 'A La Carte';

  @Column({
    field: 'lastModAvailInstore',
    hidden: true,
    title: 'Last Modified Availability In-Store',
    order: 14,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModAvailInstore?: Date;

  @Column({
    field: 'lastModAvailDelivery',
    hidden: true,
    title: 'Last Modified Availability Delivery',
    order: 15,
    pipeToken: DatePipe,
    pipeArgs: ['MM/dd/yyyy hh:mm a'],
    type: 'date',
    width: 170,
    filterType: 'date',
    filterable: true,
  })
  lastModAvailDelivery?: Date;

  id: string;
  constructor(changeset?: Partial<AllAvailabilityChangeset>) {
    this.id = changeset?.id || '';
    this.restaurantId = changeset?.restaurantId || '';
    this.restaurantName = changeset?.restaurantName || '';
    this.tierName = changeset?.tierName || '';
    this.plu = changeset?.plu || '';
    this.parItemId = changeset?.parItemId || '';
    this.itemName = changeset?.itemName || '';
    this.itemDescription = changeset?.itemDescription || '';
    this.isActive = changeset?.isActive;
    this.newAvailability =
      changeset?.newAvailability !== null
        ? changeset?.newAvailability
        : changeset.isActive;
    this.availabilityScheduledDate = changeset?.availabilityScheduledDate
      ? new Date(changeset.availabilityScheduledDate)
      : null;
    this.pricingScheduledDate = changeset?.pricingScheduledDate
      ? new Date(changeset.pricingScheduledDate)
      : null;
    this.deliveryAvailability1P = changeset?.deliveryAvailability1P;
    this.deliveryAvailability3P = changeset?.deliveryAvailability3P;
    this.newDeliveryAvailability1P =
      changeset?.newDeliveryAvailability1P !== null
        ? changeset?.newDeliveryAvailability1P
        : changeset.deliveryAvailability1P;
    this.newDeliveryAvailability3P =
      changeset?.newDeliveryAvailability3P !== null
        ? changeset?.newDeliveryAvailability3P
        : changeset.deliveryAvailability3P;
    this.categoryName = changeset?.categoryName || '';
    this.itemType = changeset?.itemType || 'A La Carte';
    this.status = changeset?.status;
    this.lastModAvailDelivery = changeset?.lastModAvailDelivery;
    this.lastModAvailInstore = changeset?.lastModAvailInstore;
  }
}
export class GridRowAllAvailabilityChangeset extends GridRow(
  AllAvailabilityChangeset
) {}
